import { ModuleWithProviders, NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AccountGuard } from '@conpulse-web/core';

const routes: Routes = [
  {
    path: 'account',
    loadChildren: () => import('./layouts/account-dashboard/accounts.module').then((m) => m.AccountsModule),
    canActivate: [AccountGuard],
  },
  {
    path: '',
    loadChildren: () => import('./layouts/auth-dashboard/auth.module').then((m) => m.AuthModule),
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
